<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="1 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4" />
</svg>